















































































































import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
//  types
import { VesselGroup } from "@/types/vesselGroup";
import { ExtendedVessel } from "@/types/vessel";
//  modules
import VesselGroupsModule from "@/store/clients/VesselGroups.module";
import VesselGroupFilter from "./VesselGroup/VesselGroupFilter.vue";

const VesselGroups = getModule(VesselGroupsModule, store);

@Component({
  components: {
    VesselGroupFilter,
  },
})
export default class DFIVesselSelect extends Vue {
  @PropSync("selectedVesselsList", { type: Array, default: () => [] }) syncSelectedVesselsList!: ExtendedVessel[];
  @Prop({ type: Array, default: () => [], required: true }) vesselsList!: ExtendedVessel[];
  @Prop({ type: Array, default: () => [] }) requiredFeatures!: string[];

  //  @Data
  searchQuery = "";
  vesselGroup: VesselGroup | null = null;
  selectedGroupIds: number[] = [];

  //  @Getters
  //returns vessels, and filters by vessel group if one is selected
  get filteredExtendedVessels(): ExtendedVessel[] {
    let vessels: ExtendedVessel[] = this.vesselsList;

    // Filter by selected group(s) if any
    if (this.selectedGroupIds.length > 0) {
      const selectedVesselIds = this.vesselGroups.filter(group => this.selectedGroupIds.includes(group.id)).flatMap(group => group.vesselIds);
      vessels = vessels.filter(vessel => selectedVesselIds.includes(vessel.id));
    }

    // Filter by search query if not empty
    if (this.searchQuery.trim()) {
      const query = this.searchQuery.trim().toLowerCase();
      vessels = vessels.filter(vessel => vessel.name.toLowerCase().includes(query) || (vessel.imoNumber && vessel.imoNumber.toString().includes(query)));
    }

    return vessels;
  }

  get vesselGroups(): VesselGroup[] {
    return VesselGroups.vesselGroups;
  }

  get selectableVessels(): ExtendedVessel[] {
    return this.filteredExtendedVessels.filter(vessel => this.hasRequiredFeaturesEnabled(vessel));
  }

  get isAllSelected(): boolean {
    return this.selectableVessels.length > 0 && this.selectableVessels.every(vessel => this.syncSelectedVesselsList.some(sel => sel.id === vessel.id));
  }
  set isAllSelected(value: boolean) {
    if (value) {
      // Select all enabled vessels
      const toAdd = this.selectableVessels.filter(vessel => !this.syncSelectedVesselsList.some(sel => sel.id === vessel.id));
      this.syncSelectedVesselsList.push(...toAdd);
      toAdd.forEach(vessel => this.onVesselChange(vessel));
    } else {
      // Unselect all enabled vessels
      const toRemove = this.syncSelectedVesselsList.filter(vessel => this.selectableVessels.some(sel => sel.id === vessel.id));
      this.syncSelectedVesselsList = this.syncSelectedVesselsList.filter(vessel => !this.selectableVessels.some(sel => sel.id === vessel.id));
      toRemove.forEach(vessel => this.onVesselChange(vessel));
    }
  }

  onVesselChange(vessel: ExtendedVessel): void {
    this.$emit("onVesselChange", vessel);
  }

  hasRequiredFeaturesEnabled(vessel: ExtendedVessel): boolean {
    const vesselEnabledFeaturesNameList = vessel.features.map(feature => feature.name);
    return this.requiredFeatures.every(feature => vesselEnabledFeaturesNameList.includes(feature));
  }

  requiredFeaturesMissing(vessel: ExtendedVessel): string[] {
    const vesselEnabledFeaturesNameList = vessel.features.map(feature => feature.name);
    const missingFeatures = this.requiredFeatures.filter(feature => !vesselEnabledFeaturesNameList.includes(feature));
    return missingFeatures.map(f => (f === "Notifications" ? "Alerts" : f));
  }

  // @Hooks
  async created(): Promise<void> {
    await VesselGroups.getAll();
  }
}
